export const FETCH_ECS_COMPANY_LIST_END = "setEcsCompanyList";
export const FETCH_ECS_COMPANY_START = "setLoadingEcsCompany";
export const SET_ECS_COMPANY = "setEcsCompany";
export const TOGGLE_MANAGE_COMPANY_EDIT_STATE = "toggleManageCompanyEditState";
export const UPDATE_MANAGE_COMPANY_FIELD = "updateManageCompanyField";
export const LOAD_ECS_COMPANY_TO_EDIT = "LOAD_ECS_COMPANY_TO_EDIT";
export const TOGGLE_EDIT_ECS_COMPANY_DIALOG = "TOGGLE_EDIT_ECS_COMPANY_DIALOG";
export const RESET_DEFAULT_NEW_ECS_COMPANY = "RESET_DEFAULT_NEW_ECS_COMPANY";
export const RESET_DEFAULT_NEW_ECS_COMPANY_LIST = "RESET_DEFAULT_NEW_ECS_COMPANY_LIST";
export const TOGGLE_NEW_ECS_COMPANY_DIALOG = "TOGGLE_NEW_ECS_COMPANY_DIALOG";
export const UPDATE_ECS_COMPANY_FIELD = "UPDATE_ECS_COMPANY_FIELD";
export const RESET_DEFAULT_ECS_COMPANY_TO_EDIT = "RESET_DEFAULT_ECS_COMPANY_TO_EDIT";
export const UPDATE_ADD_ECS_COMPANY_FIELD = "UPDATE_ADD_ECS_COMPANY_FIELD";
